import { useEffect, useState } from "react";

interface ProductGalleryProps {
  images: string[];
  alt: string;
  activeIndex?: number;
  onActiveIndexChange?: (index: number) => void;
}

export default function ProductGallery({ images, alt, activeIndex: controlledIndex, onActiveIndexChange }: ProductGalleryProps) {
  const [internalIndex, setInternalIndex] = useState(controlledIndex ?? 0);

  useEffect(() => {
    if (controlledIndex !== undefined) setInternalIndex(controlledIndex);
  }, [controlledIndex]);

  const activeIndex = Math.min(internalIndex, images.length - 1);

  const selectIndex = (index: number) => {
    setInternalIndex(index);
    onActiveIndexChange?.(index);
  };

  return (
    <div className="flex w-full flex-col gap-4 lg:flex-row">
      <div className="order-2 flex gap-3 overflow-x-auto lg:order-1 lg:w-20 lg:flex-col lg:overflow-visible">
        {images.map((image, index) => (
          <button
            key={image}
            type="button"
            aria-label={`Ver imagem ${index + 1}`}
            onClick={() => selectIndex(index)}
            className={`h-20 w-16 shrink-0 overflow-hidden rounded-md border transition-all lg:h-24 lg:w-full ${
              index === activeIndex
                ? "border-primary-500 ring-1 ring-primary-300"
                : "border-background-200 hover:border-primary-300"
            }`}
          >
            <img src={image} alt={`${alt} - imagem ${index + 1}`} className="h-full w-full object-cover object-top" />
          </button>
        ))}
      </div>

      <div className="order-1 flex-1 lg:order-2">
        <div className="relative w-full overflow-hidden rounded-lg bg-background-100">
          <div className="aspect-[4/5] w-full">
            <img
              src={images[activeIndex]}
              alt={alt}
              title={alt}
              className="h-full w-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
